import { c as _c } from "react/compiler-runtime";
import { type PublicUser } from '@shared/all/domains/user';
import React from 'react';
import { ModalContent } from '../HOC/Modal';
type Props = {
  publicUser: PublicUser;
};
const UserInfo = t0 => {
  const $ = _c(15);
  const {
    publicUser
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center justify-between"><h2 className="text-start text-xl font-semibold">Info</h2></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== publicUser.bio) {
    t2 = <p className="text-start text-textSecondary/60">Bio: {publicUser.bio}</p>;
    $[1] = publicUser.bio;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="mr-1 text-sm text-textSecondary/60">followers</span>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== publicUser.followersCount) {
    t4 = <span>{t3}{publicUser.followersCount}</span>;
    $[4] = publicUser.followersCount;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="mr-1 text-sm text-textSecondary/60">following</span>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== publicUser.followingCount) {
    t6 = <span>{t5}{publicUser.followingCount}</span>;
    $[7] = publicUser.followingCount;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <div className="flex items-center gap-x-2 text-start">{t4}{t6}</div>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t2 || $[13] !== t7) {
    t8 = <ModalContent>{t1}{t2}{t7}</ModalContent>;
    $[12] = t2;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
export default UserInfo;